import { useEffect, useState } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { About } from "./components/About";
import { Houses } from "./components/Houses";
import { Experiences } from "./components/Experiences";
import { Gallery } from "./components/Gallery";
import { Booking } from "./components/Booking";
import { Footer } from "./components/Footer";

const EMPTY = { name: "", email: "", phone: "", house: "marias", checkin: "", checkout: "", guests: "2", notes: "" };

function App() {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.3, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);


  return (
    <div className="App bg-[#F7F5F0]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Houses />
        <Experiences />
        <Gallery />
        <Booking form={form} setForm={setForm} />
      </main>
      <Footer />
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
